// Module
var code = "<div class=\"cursor\" data-cursor></div>";
// Exports
export default code;